import React, { useState, useEffect, useMemo } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import { baseUrl } from "../../../../../../../../../../../network/constants/constants";
import { getConfig } from "../../../../../../../../../../../network/auth";
import axios from "../../../../../../../../../../../network/api";

const ServiceImportForm = ({
  open,
  onClose,
  franchiseId,
  franchiseList,
  setLoading,
  selectedServiceList,
  setSelectedServiceList,
  onSubmit,
}) => {
  const [selectedFranchise, setSelectedFranchise] = useState(franchiseId);
  const [importService, setImportService] = useState([]);

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchServicImport = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/template-list/${selectedFranchise}/`, config)
      .then((response) => {
        setLoading(false);
        setImportService(response.data);
      })
      .catch((error) => {
        console.error("Import Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchServicImport();
  }, [selectedFranchise]);

  const [activeStep, setActiveStep] = useState(0);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const steps = ["Select Services", "Review Selection"];

  const handleServiceSelection = (service) => {
    if (!service || !service.id) return;

    setSelectedServiceList((prev) => {
      const exists = prev.includes(service.id);
      return exists
        ? prev.filter((id) => id !== service.id)
        : [...prev, service.id];
    });
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = () => {
    if (!selectedServiceList || selectedServiceList.length === 0) return;
  
    onSubmit(); 
    setSelectedServiceList([]); 
    setActiveStep(0);
    onClose();
  };
  const handleClose = () => {
    setSelectedServiceList([]); 
    setSelectedFranchise(franchiseId);
    setActiveStep(0); 
    onClose();
  };
  

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle style={{ color: "#ff4d4d" }}>Service Import</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{ marginBottom: 16, marginTop: 16 }}>
            <InputLabel>Franchise</InputLabel>
            <Select
              value={selectedFranchise}
              onChange={(e) => setSelectedFranchise(e.target.value)}
              label="Franchise"
            >
              {franchiseList.map((franchise) => (
                <MenuItem key={franchise.id} value={franchise.id}>
                  {franchise.business_title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  sx={{
                    "& .MuiStepLabel-label": {
                      color: activeStep === index ? "#ff4d4d" : "gray",
                    },
                    "& .MuiStepIcon-root": {
                      color: activeStep === index ? "#ff4d4d" : "gray",
                    },
                    "& .MuiStepIcon-text": {
                      fill: "white",
                    },
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          <Box mt={2}>
            {activeStep === 0 && (
              <div>
                {importService &&
                  importService.map((category) => (
                    <div key={category.id}>
                      <Typography
                        variant="p"
                        style={{ marginTop: "10px", color: "#1976d2" }}
                      >
                        {category.name}
                      </Typography>
                      <Box ml={2}>
                        {category.services &&
                          category.services.map((service) => (
                            <FormControlLabel
                              key={service.id}
                              control={
                                <Checkbox
                                  checked={selectedServiceList.includes(
                                    service.id
                                  )}
                                  onChange={() =>
                                    handleServiceSelection(service)
                                  }
                                />
                              }
                              label={service.service_name}
                            />
                          ))}
                      </Box>
                    </div>
                  ))}
              </div>
            )}
            {activeStep === 1 && (
              <div>
                <Typography variant="h6">Review Selection</Typography>
                <ul>
                  {selectedServiceList.map((serviceId) => {
                  
                    const service = importService
                      .flatMap((category) => category.services)
                      .find((service) => service.id === serviceId);

                    return service ? (
                      <li key={service.id}>{service.service_name}</li>
                    ) : null;
                  })}
                </ul>
              </div>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            variant="contained"
            color="secondary"
          >
            Back
          </Button>
          {activeStep === steps.length - 1 ? (
            <Button onClick={handleSubmit} variant="contained" color="success">
              Submit
            </Button>
          ) : (
            <Button onClick={handleNext} variant="contained" color="primary">
              Next
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ServiceImportForm;
